import chat from './chat/reducer';
import session from './session/reducer';
import errors from './errors';

export default {
  chat,
  session,
  errors,
};
